import { type Ref, computed } from 'vue';

/**
 * Composable that provides array interface for Set operations
 * @param setRef - Reactive Set reference
 * @returns WritableComputedRef that behaves like array but operates on Set
 */
export const useProxySetToArray = <T extends string | number>(setRef: Ref<Set<T>>) => {
    return computed({
        get: () => Array.from(setRef.value),
        set: (newArray: T[]) => {
            setRef.value = new Set(newArray);
        }
    });
};
